const UNIT = 1024;
const UNITS = ['B', 'kB', 'MB', 'GB', 'TB'];

export const formatSize = (size: number): string => {
  const unitsIndex = Math.floor(Math.log(size) / Math.log(UNIT));
  return `${(size / UNIT ** unitsIndex).toFixed(2)} ${UNITS[unitsIndex]}`;
};
